import DocumentIcon from "@assets/icons/document"
import styles from "./OtherUsefulApps.module.css"
import OtherUsefulAppCard from "./OtherUsefulApp"
import SunIcon from "@assets/icons/sun"
import ColorSwatchIcon from "@assets/icons/colorSwatch"
import EyeIcon  from "@assets/icons/eyeLight"
import ForMoreAppsCard from "./ForMoreApps"
import PersonSittingIcon from "@assets/icons/personSittingIcon"
import ArrowSquareLeftIcon from "@assets/icons/arrowSquareLeft"
import GoBack from "@components/Common/GoBack"
const OtherUsefulApps = () => {
  return (
    <>
      <div className={styles.header}>
        <h1 className={styles.heading}>Other Useful Apps</h1>
        <p className={styles.description}>
          One Place Solution for all your needs, Try other AI-Powered Diagnostic
          Software.
        </p>
        <GoBack className={styles.mobileBackButton}>
          <ArrowSquareLeftIcon />
        </GoBack>
        <h2 className={styles.resourceLibrary}>RESOURCE LIBRARY</h2>
      </div>

      <div className={styles.mainContent}>
        <div className={styles.UsefullAppCardsWrapper}>
          <OtherUsefulAppCard
            name="Optics Chart App"
            description="Eye care practice with online chart app to diagnose and test"
            appLink="https:chart.orbsway.com"
          >
            <DocumentIcon />
          </OtherUsefulAppCard>
          <OtherUsefulAppCard
            name="Workflow Manager"
            description="Smart and Interactive patient process management system"
          >
            <SunIcon />
          </OtherUsefulAppCard>
          <OtherUsefulAppCard
            name="Smartest EHR"
            description="App for pre-treatment to post-treatment. Smartly handle metrics and image"
          >
            <ColorSwatchIcon />
          </OtherUsefulAppCard>
          <OtherUsefulAppCard
            name="Telehealth"
            description=" Engage online eye care consultation integrated to eye care tests"
          >
            <EyeIcon />
          </OtherUsefulAppCard>
        </div>
        <div className={styles.rightSection}>
          <PersonSittingIcon />
          <ForMoreAppsCard />
        </div>
      </div>
    </>
  )
}

export default OtherUsefulApps
